/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'

const PairLazyRouteImport = createFileRoute('/pair')()
const FinanceLazyRouteImport = createFileRoute('/finance')()
const AboutLazyRouteImport = createFileRoute('/about')()
const IndexLazyRouteImport = createFileRoute('/')()
const LibraryIndexLazyRouteImport = createFileRoute('/library/')()
const JournalIndexLazyRouteImport = createFileRoute('/journal/')()
const JournalDateLazyRouteImport = createFileRoute('/journal/$date')()
const LibraryBooksBookIdLazyRouteImport = createFileRoute(
  '/library/books/$bookId',
)()

const PairLazyRoute = PairLazyRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/pair.lazy').then((d) => d.Route))
const FinanceLazyRoute = FinanceLazyRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/finance.lazy').then((d) => d.Route))
const AboutLazyRoute = AboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const LibraryIndexLazyRoute = LibraryIndexLazyRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/library.index.lazy').then((d) => d.Route))
const JournalIndexLazyRoute = JournalIndexLazyRouteImport.update({
  id: '/journal/',
  path: '/journal/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/journal.index.lazy').then((d) => d.Route))
const JournalDateLazyRoute = JournalDateLazyRouteImport.update({
  id: '/journal/$date',
  path: '/journal/$date',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/journal.$date.lazy').then((d) => d.Route))
const LibraryBooksBookIdLazyRoute = LibraryBooksBookIdLazyRouteImport.update({
  id: '/library/books/$bookId',
  path: '/library/books/$bookId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/library.books.$bookId.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/finance': typeof FinanceLazyRoute
  '/pair': typeof PairLazyRoute
  '/journal/$date': typeof JournalDateLazyRoute
  '/journal/': typeof JournalIndexLazyRoute
  '/library/': typeof LibraryIndexLazyRoute
  '/library/books/$bookId': typeof LibraryBooksBookIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/finance': typeof FinanceLazyRoute
  '/pair': typeof PairLazyRoute
  '/journal/$date': typeof JournalDateLazyRoute
  '/journal': typeof JournalIndexLazyRoute
  '/library': typeof LibraryIndexLazyRoute
  '/library/books/$bookId': typeof LibraryBooksBookIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/finance': typeof FinanceLazyRoute
  '/pair': typeof PairLazyRoute
  '/journal/$date': typeof JournalDateLazyRoute
  '/journal/': typeof JournalIndexLazyRoute
  '/library/': typeof LibraryIndexLazyRoute
  '/library/books/$bookId': typeof LibraryBooksBookIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/finance'
    | '/pair'
    | '/journal/$date'
    | '/journal/'
    | '/library/'
    | '/library/books/$bookId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/finance'
    | '/pair'
    | '/journal/$date'
    | '/journal'
    | '/library'
    | '/library/books/$bookId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/finance'
    | '/pair'
    | '/journal/$date'
    | '/journal/'
    | '/library/'
    | '/library/books/$bookId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AboutLazyRoute: typeof AboutLazyRoute
  FinanceLazyRoute: typeof FinanceLazyRoute
  PairLazyRoute: typeof PairLazyRoute
  JournalDateLazyRoute: typeof JournalDateLazyRoute
  JournalIndexLazyRoute: typeof JournalIndexLazyRoute
  LibraryIndexLazyRoute: typeof LibraryIndexLazyRoute
  LibraryBooksBookIdLazyRoute: typeof LibraryBooksBookIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journal/': {
      id: '/journal/'
      path: '/journal'
      fullPath: '/journal/'
      preLoaderRoute: typeof JournalIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journal/$date': {
      id: '/journal/$date'
      path: '/journal/$date'
      fullPath: '/journal/$date'
      preLoaderRoute: typeof JournalDateLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/books/$bookId': {
      id: '/library/books/$bookId'
      path: '/library/books/$bookId'
      fullPath: '/library/books/$bookId'
      preLoaderRoute: typeof LibraryBooksBookIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AboutLazyRoute: AboutLazyRoute,
  FinanceLazyRoute: FinanceLazyRoute,
  PairLazyRoute: PairLazyRoute,
  JournalDateLazyRoute: JournalDateLazyRoute,
  JournalIndexLazyRoute: JournalIndexLazyRoute,
  LibraryIndexLazyRoute: LibraryIndexLazyRoute,
  LibraryBooksBookIdLazyRoute: LibraryBooksBookIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
